import { buildCartLineValidityCapture } from "@/domain/cart/cart-line-capture";
import type { MenuCatalogItem, MenuCatalogSnapshot } from "@/domain/cart/cart-validity.types";
import type { CartLine } from "@/shared/cart/model.types";

function findCatalogItem(catalog: MenuCatalogSnapshot, menuItemId: string): MenuCatalogItem | undefined {
  const id = String(menuItemId).trim();
  return catalog.items.find((item) => String(item.menu_item_id) === id);
}

/**
 * Attaches explicit validity capture metadata to reorder cart lines from the live catalog.
 * Uses catalog prices and menu versions — not historical order amounts.
 */
export function attachReorderValidityCapture(
  lines: ReadonlyArray<CartLine>,
  catalog: MenuCatalogSnapshot
): CartLine[] {
  if (!catalog.loaded) {
    return lines.map((line) => ({ ...line }));
  }

  return lines.map((line) => {
    const catalogItem = findCatalogItem(catalog, line.menu_item_id);
    if (!catalogItem) {
      return { ...line };
    }

    const validityCapture = buildCartLineValidityCapture({
      item_price: catalogItem.item_price,
      menu_version: catalogItem.menu_version,
      catalog_fingerprint: catalog.fingerprint,
      selected_modifiers: line.selected_modifiers,
    });

    return {
      ...line,
      validityCapture,
    };
  });
}
